import axiosPrivate from "@services/axiosPrivate";
export const viewUsers = (filters) => {
  return axiosPrivate.get(`/getPostPayDoctor`, { params: filters });
};
